import { combineReducers } from 'redux';

import consultaMunicipios from './municipios/reducer';
import consultaNaturalidades from './naturalidade/reducer';

export default combineReducers({
	consultaMunicipios,
	consultaNaturalidades,
});
